import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthHelperService} from '../services/auth-helper.service';

@Injectable({
  providedIn: 'root',
})
export class HasTenantGuard implements CanActivate {
  constructor(private _authHelper: AuthHelperService, private _router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const hasAtLeastOneTenant = this._authHelper.hasAtLeastOneTenant();
    if (!hasAtLeastOneTenant) {
      this._router.navigate(['/missing-tenant']);
    }

    return hasAtLeastOneTenant;
  }
}
